import React, { useState, useEffect, startTransition } from 'react'
import { Switch } from '@ui-pc'
import styles from './formItem.module.scss'

interface FormItemProps {
  customClass?: string
  label?: string
  item?: {
    type?: string
    length?: number
    placeholder?: string
    clearable?: boolean
    hasError?: boolean
    error?: any // api提示
    emptyError?: string // 空值提示
    valueError?: string // 有值提示
    isClearValue?: boolean
    eyes?: boolean
    rule?: () => void
    validate?: () => void
    value?: string
    customError?: boolean
  }
  value?: string
  onUpdateValue?: (value: string) => void
  onError?: () => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  inputStyle?: React.CSSProperties
}

const FormItem: React.FC<FormItemProps> = ({
  customClass,
  label = '',
  item = {},
  onUpdateValue = () => {},
  onBlur = () => {},
  inputStyle = {}
}) => {
  const [type, setType] = useState<string>(item.type)
  const [val, setVal] = useState<string>(item.value || '')

  const clear = () => {
    setVal('')
    handleChangeValue('')
  }

  const switchType = () => {
    setType((prevType) => (prevType === 'password' ? 'text' : 'password'))
  }

  const handleChangeValue = (value) => {
    const newValue = value?.trim() || ''
    setVal(newValue)
    onUpdateValue && onUpdateValue(newValue)
    if (!item.isClearValue) {
      item.validate?.()
    }
  }

  const blurInput = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlur && onBlur(e)
  }

  useEffect(() => {
    setVal(item.value?.trim() || '')
  }, [item.value])

  return (
    <div
      className={`${styles['input-container']} ${styles[customClass]} ${
        item.hasError ? styles['has-error'] : ''
      }`}>
      {/* label展示 */}
      <Switch either={!!label}>
        <div className={styles['label-style']}>{label}</div>
      </Switch>
      {/* 输入框 */}
      <section className={styles['input-row']}>
        <input
          value={val}
          type={type}
          maxLength={item.length}
          placeholder={item.placeholder}
          className={`${styles['input-item']} ${val ? styles['not-empty'] : ''}`}
          onBlur={blurInput}
          onChange={(e) => handleChangeValue(e.target.value)}
          style={{ ...inputStyle }}
        />

        <div className={styles['icons']}>
          <Switch either={item.clearable && val !== ''}>
            <i
              className={`iconfont cursor-pointer icon-close1 ${styles.closeIcon}`}
              onClick={clear}
            />
          </Switch>
          <Switch either={item.type === 'password'}>
            <i
              className={`iconfont cursor-pointer ${
                type === 'password' ? 'icon-ic_hide' : 'icon-ic_open'
              } ${styles.eyeIcon}`}
              onClick={switchType}
            />
          </Switch>
        </div>
      </section>
      {/* 错误提示，充当占位高度 */}
      <Switch either={!item.customError}>
        {/* 优先显示其他错误信息，再显示默认错误信息 */}
        <Switch either={!!item.error}>
          <div className={`${styles['error']} apiError error`}>
            {item.error}
          </div>
          <div className={`${styles['error']} error`}>
            {val ? item.valueError : item.emptyError}
          </div>
        </Switch>
      </Switch>
    </div>
  )
}

export default FormItem
